
import { Component, Vue, Prop, computed } from 'vue-property-decorator'
// import { CreateHotTaskModal } from '@/components'
import FetchWrapper from '@/classes/fetchWrapper'

const ApiCardProps = Vue.extend({
  props: {
    supplier: String,
    description: String,
    apiKey: String,
    idx: Number,
    credits: Number,
    userId: Number,
    type: String
  }
})

@Component
export default class ApiCard extends ApiCardProps {
  data () {
    return {
      isNewTaskModalOpen: false,
      isLoading: false
    }
  }

  emitUpdateRequest () {
    this.$emit('updateRequest', { idx: this.idx, type: this.type, key: this.apiKey })
  }

  emitDeleteRequest () {
    this.$emit('deleteRequest', { idx: this.idx, type: this.type })
  }

  get isLoggedIn () {
    return this.$store.state.loggedIn
  }
}
